export default "__VITE_ASSET__Bjf7lPYj__"